import globalTheme from '../global'

const Container = {
	MuiContainer: {
		styleOverrides: {
			root: {
				paddingLeft: globalTheme.spacing(3),
				paddingRight: globalTheme.spacing(3),
			},
			disableGutters: {
				paddingLeft: 0,
				paddingRight: 0,
			},
		},
	},
}

export default Container
